// pages/Contact.js
import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import MyNavbar from '../components/MyNavbar';
import Footer from '../components/Footer';
import emailjs from '@emailjs/browser';
import ReCAPTCHA from "react-google-recaptcha";  

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
        inquiryType: 'general'
    });
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [errorAlert, setErrorAlert] = useState(false);

    const handleCaptchaChange = (value) => {
        console.log("Captcha value:", value);
        setCaptchaVerified(true);
    };
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
         // Replace with your actual EmailJS credentials
        const SERVICE_ID = 'service_7bcadib';     // <-- from EmailJS Dashboard
        const TEMPLATE_ID = 'template_ati2u4f';   // <-- from your Email Template
        const PUBLIC_KEY = 'EJln-bRgPHOZxCqP8';     // <-- from your EmailJS Account → API Keys

        // Send the email via EmailJS
        emailjs.send(
            SERVICE_ID,
            TEMPLATE_ID,
            {
                from_name: formData.name,
                from_email: formData.email,
                subject: formData.subject,
                message: formData.message,
                inquiry_type: formData.inquiryType,
            },
            PUBLIC_KEY
        )
        .then((response) => {
            console.log('SUCCESS!', response.status, response.text);
            setShowAlert(true);
            setErrorAlert(false);

            // Reset form
            setFormData({
                name: '',
                email: '',
                subject: '',
                message: '',
                inquiryType: 'general'
            });
            setCaptchaVerified(false);
            // Hide success alert after 5 seconds
            setTimeout(() => setShowAlert(false), 5000);
        })
        .catch((err) => {
            console.error('FAILED...', err);
            setErrorAlert(true);
            setShowAlert(false);
        });
    };

    return (
        <div className="contact-page">
            <MyNavbar />

            {/* Hero Section */}
            <section style={{
                backgroundColor: '#0A4B5D',
                color: 'white',
                paddingTop: '5rem',
                paddingBottom: '3rem'
            }}>
                <Container >
                    <Row className="text-center">
                        <Col lg={8} className="mx-auto">
                            <h1 className="display-4 fw-bold mb-4">Contact Us</h1>
                            <p className="lead">
                                Get in touch with the Translational Bioinformatics Research Lab.
                                We're always interested in collaborations, research opportunities, and answering your questions.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Contact Form & Information */}
            <section className="py-5">
                <Container>
                    <Row>
                        {/* Contact Form */}
                        <Col lg={8} className="mb-5">
                            <Card className="shadow border-0">
                                <Card.Body className="p-4">
                                    <h3 className="mb-4" style={{ color: '#0A4B5D' }}>Send us a Message</h3>

                                    {showAlert && (
                                        <Alert variant="success" className="mb-4">
                                            Thank you for your message! We'll get back to you soon.
                                        </Alert>
                                    )}

                                    <Form onSubmit={handleSubmit}>
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Full Name *</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                        required
                                                        placeholder="Enter your full name"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Email Address *</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        required
                                                        placeholder="Enter your email"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Inquiry Type</Form.Label>
                                            <Form.Select
                                                name="inquiryType"
                                                value={formData.inquiryType}
                                                onChange={handleChange}
                                            >
                                                <option value="general">General Inquiry</option>
                                                <option value="collaboration">Research Collaboration</option>
                                                <option value="students">Student Opportunities</option>
                                                <option value="technical">Technical Support</option>
                                                <option value="other">Other</option>
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Subject *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="subject"
                                                value={formData.subject}
                                                onChange={handleChange}
                                                required
                                                placeholder="Enter message subject"
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-4">
                                            <Form.Label>Message *</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={6}
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                                placeholder="Tell us about your inquiry..."
                                            />
                                        </Form.Group>
                                        <div className="mb-4">
                                            <ReCAPTCHA
                                                sitekey="6LdJe_wrAAAAAIksRSBkW2O1oaNuC-k40r8sxqOi"
                                                onChange={handleCaptchaChange}
                                            />
                                        </div>
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            size="lg"
                                            disabled={!captchaVerified} 
                                            style={{
                                                backgroundColor: '#007BFF',
                                                borderColor: '#007BFF'
                                            }}
                                        >
                                            Send Message
                                        </Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Contact Information */}
                        <Col lg={4}>
                            <Card className="shadow border-0 mb-4">
                                <Card.Body className="p-4">
                                    <h4 style={{ color: '#0A4B5D' }} className="mb-4">Contact Information</h4>

                                    <div className="contact-item mb-4">
                                        <div className="d-flex align-items-start">
                                            <i className="fas fa-user-md fa-lg me-3 mt-1" style={{ color: '#007BFF' }}></i>
                                            <div>
                                                <h6 className="mb-1">Dr. Trupti Joshi</h6>
                                                <p className="text-muted mb-0">Senior Associate Dean for Informatics & Population Analytics</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="contact-item mb-4">
                                        <div className="d-flex align-items-start">
                                            <i className="fas fa-envelope fa-lg me-3 mt-1" style={{ color: '#007BFF' }}></i>
                                            <div>
                                                <h6 className="mb-1">Email</h6>
                                                <p className="text-muted mb-0">joshitr@marshall.edu</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="contact-item mb-4">
                                        <div className="d-flex align-items-start">
                                            <i className="fas fa-map-marker-alt fa-lg me-3 mt-1" style={{ color: '#007BFF' }}></i>
                                            <div>
                                                <h6 className="mb-1">Location</h6>
                                                <p className="text-muted mb-0">
                                                    Joan C. Edwards School of Medicine<br />
                                                    Marshall University<br />
                                                    Huntington, WV 25755
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="contact-item mb-4">
                                        <div className="d-flex align-items-start">
                                            <i className="fas fa-building fa-lg me-3 mt-1" style={{ color: '#007BFF' }}></i>
                                            <div>
                                                <h6 className="mb-1">Department</h6>
                                                <p className="text-muted mb-0">
                                                    Biomedical Sciences
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Map Section */}
            <section className="py-5 bg-light">
                <Container>
                    <Row className="text-center mb-4">
                        <Col>
                            <h3 style={{ color: '#0A4B5D' }}>Visit Our Campus</h3>
                            <p className="text-muted">Marshall University - Joan C. Edwards School of Medicine</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card className="shadow border-0">
                                <Card.Body className="p-0">
                                    {/* Placeholder for Google Maps - Replace with actual embed code */}
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3155.123456789!2d-82.394234!3d38.423456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8845c123456789ab%3A0x1234567890abcdef!2sMarshall%20University!5e0!3m2!1sen!2sus!4v1234567890"
                                        width="100%"
                                        height="400"
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                    ></iframe>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Footer />
        </div>
    );
};

export default Contact;